import { CheckOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Tooltip } from 'antd';
import { useMemo } from 'react';

interface CheckButtonProps {
  checked?: boolean;
  disabled?: boolean;
  color?: 'blue' | 'black';
  disabledTooltip?: string;
}

export const QAPairCheckButton = (props: CheckButtonProps) => {
  const { checked = false, color = 'black', disabled, disabledTooltip } = props;

  const theme = useMemo(() => {
    if (color === 'blue') {
      return 'bg-[#336fff] !border-[#336fff] hover:border-[#336fff]';
    }
    return 'bg-[#404040] !border-[#404040] hover:border-[#404040]';
  }, [color]);

  const content = (
    <div
      className={cx(
        'w-[20px] h-[20px] rounded-full border border-solid border-[#A7A7A7] flex-shrink-0 cursor-pointer flex items-center justify-center text-[#FFFFFF]',
        {
          [theme]: checked,
          '!bg-[#D8D8D8] !cursor-not-allowed': disabled,
        },
      )}
    >
      {checked && <CheckOutlined />}
    </div>
  );

  if (disabled && !!disabledTooltip) {
    return <Tooltip title={disabledTooltip}>{content}</Tooltip>;
  }

  return content;
};
